"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorText = exports.FooterContainer = exports.ModalContentContainer = exports.StyledAlert = exports.SpacedCheckbox = exports.SpacedButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.SpacedButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-inline-start: ", ";\n"], ["\n  margin-inline-start: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.SpacedCheckbox = (0, styled_components_1.default)(storm_ui_1.Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.StyledAlert = (0, styled_components_1.default)(storm_ui_1.Alert)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.medium;
});
exports.ModalContentContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 400px;\n"], ["\n  max-width: 400px;\n"])));
exports.FooterContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n"])));
exports.ErrorText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-basis: 100%;\n  color: ", ";\n  text-align: right;\n"], ["\n  flex-basis: 100%;\n  color: ", ";\n  text-align: right;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.auired;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
